export class SimpleOffer {
    constructor(public data?: {
        OfferID?: Number,
        OfferNumber?: String,
        ProductType?: Number,
        ContractorFirstname?: String,
        ContractorLastname?: String,
        ContractorJMBG?: String,
        ContractorPhoneNumber?: String,
        ContractorEmail?: String,
        ContractorCompanyName?: String,
        ContractorTaxID?: String,
        ContractorCompanyID?: String,
        ContractorIsInsuree?: Boolean,
        InsureeFirstname?: String,
        InsureeLastname?: String,
        InsureeJMBG?: String,
        InsuranceStart?: String,
        InsuranceEnd?: String,
        Duration?: Number,
        PaymentFrequency?: Number,
        SumInsured?: Number,
        PremiumRate?: Number,
        AdditionalPremiumRate?: Number,
        PaymentType?: Number,
        ClientStatusID?: Number,
        Comment?: String
    }) { }
}